export class Roles {

    roleIdAccess:number;
    roleName:string;
}
